import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// 번역 파일 import
import translationKO from './locales/ko.json';
import translationEN from './locales/en.json';

const resources = {
  ko: {
    translation: translationKO
  },
  en: {
    translation: translationEN
  }
};

// 브라우저 언어에 따른 기본 언어 설정 (디버깅 포함)
const getDefaultLanguage = () => {
  const userLocale = navigator.language || navigator.languages[0];
  const userLanguages = navigator.languages || [navigator.language];
  
  console.log('🌐 Browser language detected:', userLocale);
  console.log('🌐 All browser languages:', userLanguages);
  
  // 한국어 감지 (ko, ko-KR, ko-US 등)
  if (userLocale && userLocale.toLowerCase().startsWith('ko')) {
    console.log('✅ Korean detected, using Korean');
    return 'ko';
  }
  
  console.log('✅ Non-Korean detected, using English');
  return 'en'; // 한국어가 아니면 영어
};

i18n
  .use(LanguageDetector) // 브라우저 언어 자동 감지
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // 기본값을 영어로 변경
    debug: true, // 디버깅 활성화해서 콘솔에서 확인
    
    // 언어 감지 설정 개선
    detection: {
      // localStorage에 저장된 언어가 없으면 브라우저 언어 감지
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'], // localStorage에 선택된 언어 저장
      
      // 브라우저 언어 감지 옵션
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      
      // 감지된 언어가 지원되지 않으면 fallback 사용
      checkWhitelist: true
    },
    
    // 지원하는 언어 목록
    supportedLngs: ['ko', 'en'],
    nonExplicitSupportedLngs: true,

    interpolation: {
      escapeValue: false // React에서는 XSS 보호가 기본 제공
    },
    
    // 초기화 후 콜백으로 언어 확인
    initImmediate: false
  });

export default i18n;